import { createElement } from 'react'
import DatabaseOptimization from '~/dashboard/azure_master_optimizations/database_optimization'
import ReactController from './react_controller'

export default class AzureDatabaseOptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(DatabaseOptimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
